import { IntlProvider } from "react-intl";
import enMessages from "./en/asset.json";
import esMessages from "./es/asset.json";
import esCoMessages from "./es-co/asset.json";
import esMxMessages from "./es-mx/asset.json";
import itMessages from "./it/asset.json";
import ptMessages from "./pt/asset.json";

export const messages = {
  en: enMessages,
  es: esMessages,
  "es-co": esCoMessages,
  "es-mx": esMxMessages,
  it: itMessages,
  pt: ptMessages
};

const I18nProvider = ({
  children,
  locale = "es",
  country = "es",
}: {
  children: React.ReactNode;
  locale?: string;
  country?: string;
}) => {
  // Determine the correct locale based on language and country
  const getLocaleKey = () => {
    if (locale === "es" && country === "co") {
      return "es-co";
    }
    if (locale === "es" && country === "mx") {
      return "es-mx";
    }
    return locale;
  };

  const localeKey = getLocaleKey();

  return (
    <IntlProvider
      locale={locale}
      messages={messages[localeKey as keyof typeof messages] || messages.es}
    >
      {children}
    </IntlProvider>
  );
};

export default I18nProvider;
